import React from 'react'
import style from './clip-loader.module.css'

const ClipLoader: React.FC = () => {
    return <span className={style.clipLoader}></span>
}

export default ClipLoader
